import { 
  NewProjectFormModel, 
} from './new-project.model';

import { 
  BaseClass,
  dropProps,
} from 'src/api/models/Base/base.class';

import { InputModel } from 'src/api/models/Form/InputField/input.model';

import { InputClass } from 'src/api/models/Form/InputField/input.class';

import { 
  SelectFieldModel,
  SelectFieldClass, 
} from 'src/api/models/Form/SelectField';

import { newProjectFormData } from './new-project.data';

export class NewProjectClass extends BaseClass<NewProjectFormModel> implements NewProjectFormModel {
  get name(): InputModel {
    return dropProps(this.props.name, new InputClass(this.props.name)); 
  }
  get street(): InputModel {
    return dropProps(this.props.street, new InputClass(this.props.street)); 
  }
  get streetNr(): InputModel {
    return dropProps(this.props.streetNr, new InputClass(this.props.streetNr)); 
  }
  get zip(): InputModel {
    return dropProps(this.props.zip, new InputClass(this.props.zip)); 
  }
  get city(): InputModel {
    return dropProps(this.props.city, new InputClass(this.props.city)); 
  }
  get country(): SelectFieldModel {
    return dropProps(this.props.country, new SelectFieldClass(this.props.country)); 
  }
}

export const newProjectFormValues = (isInternalUser: boolean | undefined) => newProjectFormData && dropProps(newProjectFormData(isInternalUser), new NewProjectClass(newProjectFormData(isInternalUser)));
